import LocalizedStrings from "react-localization"; // added new strings in cp and created web report strings
import ProjectDetailsReportPage from "screens/Report/projectDetailsReport";
const strings = new LocalizedStrings({
  en: {
    // defaul error
    initialError: {
      data: {
        status: 501,
        message: "Internal error, Please try again!",
      },
    },
    sno: "S. No.",
    tableDataErr: "Data Not Available",
    modify: "Modify",
    download: "Download",
    // Login

    Login: "LOGIN",
    enterUsernameAndPass: "Enter Your Username and Password",
    username: "Username",
    password: "Password",
    loginemail: "Username is require. Please enter username.",
    loginpassword: "Password is require. Please enter password.",
    forgotPass: "Forgot Password ?",
    login: "Login",

    // Forgot Password

    forgotpass: "FORGOT PASSWORD",
    enterEmailForResetPass: "Enter Your Email for Reset Password",
    yourEmail: "Your Email",
    backToLogin: "Back To Login",
    sendOTP: "Send OTP",

    // Verify OTP

    verifyOTP: "VERIFY OTP",
    enterOTPRecivedOnEmail: "Enter OTP Recived On Email",
    enterOPT: "Enter OTP",
    resendOTP: "Resend OTP",
    verify: "Verify",

    // Resend Password

    changepass: "CHANGE PASSWORD",
    enterNewPass: "Enter Your New Password",
    newPass: "New Password",
    currentPassword: "Current Password",
    confirmPass: "Confirm Password",
    changepassword: "Change Password",

    //   header
    Search: "Search...",
    notification: "Notification",
    profile: "Profile",
    changePassword: "Change Password",
    userPasswordSend: "Reset Password",
    roleChange: "Role Change",
    propertyAllocate: "Property Allocate",
    separateLink: "Separate Link",
    logout: "Logout",

    // Dashboard

    dashboard: "DASHBOARD",
    noOfProperty: "Total Property",
    noOfUser: "Total User",
    channelParters: "Total Channel Partner",
    visitorUpdate: "VISITOR UPDATE",
    todatyVisit: "Today Lead",
    todayAppointment: "Today Site Visit", // legacy; use todayWalkins for dashboard
    todayFollowup: "Today Followup",
    todayFollowUpButton: "Today's Follow-Up",
    pendingFollowups: "Pending Followups",
    todayWalkins: "Today's Walk-ins",
    todayRevisitsScheduled: "Today's Revisits Scheduled",
    todayBooking: "Today Booking",
    todayRegistration: "Today Registration",
    totalAppointment: "Total Site Visit",
    totalFollowup: "Total Followup",
    totalBooking: "Total Booking",
    totalRegistration: "Total Registration",
    todayRaiseTicket: "Today Raise Ticket",
    openRaiseTicket: "Open Raise Ticket",
    visitG: "Visit",
    appointmentG: "Appointment",
    followupG: "Followup",
    bookingG: "Booking",
    registrationG: "Registration",
    marketValue: "MARKET VALUE",
    performance: "Performance",
    newchannelPartner: "NEW CHANNEL PARTNER",
    month: "Month",
    today: "Today",
    seemore: "SeeMore",
    follow: "Follow",
    recentNotification: "RECENT NOTIFICATION",
    all: "All",
    order: "Order",
    trash: "Trash",
    calculation: "CALCULATION",
    newLead: "New Lead",
    visitTarget: "Visit Target",
    sitevisitTarget: "Site Visit Target",
    closingTarget: "Closing Target",
    totalSiteVisit: "Total Site Visit",
    totalCloseVisit: "Total Close Visit",
    totalVisit: "Total Lead",
    activeCP: "Active CP",
    conversionRate: "Conversion Rate",
    closingScore: "Closing Score",
    recovery: "Recovery",
    cancelBooking: "Cancel Booking",
    appointmentNumber: "Appointment Number",
    walkingNumber: "Walking Number",
    todayCheckin: "Today's Checkin",
    totalCheckin: "Total Checkin",
    todayAppointmentWithCp: "Today Appointment with Cp",
    activeSm: "Active SM",
    activeCm: "Active CM",

    // Footer

    copyright: "Copyright 2022-23 © Justo All rights reserved.",

    // Common_Using_Keys
    notavailable: "NA",
    dataNotFound: "Data Not Available",
    imageNotFound: "Image Not Available",

    // User_index
    user: "USER",
    userListing: "User Listing",
    startDate: "Start Date",
    endDate: "End Date",
    byRole: "Search By Role",
    searchByEmail: "Search By Email",
    searchByParentName: "Search By Parent Name",
    searchParentName: "Search Parent Name",
    searchEmail: "Search Email",
    search: "Search",
    reset: "Reset",
    addNewUser: "Add New User",
    listOfUsers: "LIST OF USER'S",
    image: "Image",
    createdDate: "Created Date",
    name: "Name",
    contactNo: "Contact No.",
    emailId: "Email Id",
    type: "Type",
    action: "Action",
    total_users: "Total Users",
    viewUser: "View User",
    edituser: "Edit User",
    DeactiveUser: "Deactive User",
    deactive: "Deactive",
    selectrole: "Select Role",
    selectRole: "--Select Role--",
    editProfile: "Edit Profile",
    dashboardProfile: "Dashboard",
    editprofile: "EDIT PROFILE",
    profileDetail: "Profile Details",
    profileDetails: "PROFILE DETAILS",
    parentname: "Parent Name",
    agent_name: "Agent Name",
    selectall: "Select All",
    searchByCity: "Search By City Name",

    // Add New User
    addnewuser: "ADD NEW USER",
    selectImage: "Upload your image",
    addnewUser: "ADD NEW USER",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Id",
    emailaddress: "name@example.com",
    EmailUsername: "Username",
    mobileNo: "Mobile Number",
    referrerNumber: "Referrer Mobile No.",
    referrerName: "Referrer Name",
    referrerRequired: "Referrer required.",
    referrer: "Referrer",
    gender: "Gender",
    male: "Male",
    female: "Female",
    dob: "Date Of Birth",
    city: "City",
    address: "Address",
    area: "Area",
    role: "Role",
    sourcingTL: "Sourcing TL",
    selectSourcingTL: "--Select Sourcing TL--",
    closingTL: "Closing TL",
    selectClosingTL: "--Select Closing TL--",
    selectuser: "--Select User--",
    selectLoginType: "-- Select Login Type --",
    submit: "Submit",
    allFieldRequired: "Please fill all required field.",
    loginAccess: "Login Access",
    justoEmpCode: "Justo Employee Code",
    justoEmp: "Justo Emp. Code",
    referrerEmail: "Referrer Email",

    // View User
    userDetails: "USER DETAILS",
    viewuserdetails: "View User Details",
    age: "Age",
    userInfo: "Details",
    noOfBooking: "Total Booking",
    noOfCloseVisit: "Total Close Visit",
    lastVisitAttend: "Last Visit Attend",
    lastBooking: "Last Booking",
    lastReadyBooking: "Last Ready Booking",
    closeTarget: "Close Target",
    currentTarget: "Current Target",
    projectsName: "Projects Name",
    allocatedProps: "Allocated Properties",

    // Edit User
    editUser: "EDIT USER",
    editImage: "Edit your image",
    update: "Update",
    cancel: "Cancel",

    //  Deactive User
    activeUser: "Active User",
    deactiveUser: "Deactive User",
    areYouSure: "Are you sure?",
    deactiveThisUser: "Deactive This User !",
    youWantChangePassword: "You want to reset password !",
    yes: "Yes",
    no: "No",

    activeThisUser: "Active This User !",

    inventryEditDetail: "only enter a number greater than the current number",

    //user error
    role_idErr: " Role is required.",
    parentErr: " Parent is required.",
    user_idErr: " Sourcing TL is required.",
    closing_tlErr: "Closing TL is required.",
    profileImageErr: "Profile Photo is required.",
    firstnameErr: "First name is required.",
    nameValidErr: "Please enter valid name.",
    lastnameErr: "Last name is required.",
    emailErr: "Email Id is required.",
    mobileErr: " Mobile number is required.",
    mobileValidErr: "Please enter valid mobile number.",
    whatsAppNumber: "Whats'app Number is required.",
    emailRequire: "Email is require. Please enter email",
    emailAddressValidErr: "Please enter valid email.",
    otpErr: "OTP is required.",
    otpVerfiyValidErr: "Please Enter Valid OTP.",
    genderErr: "Gender is required.",
    dateofbirthErr: "Date of birth is required.",
    dateofbirthErr2: "You have to be older than 18.",
    addressErr: "Address is required.",
    cityErr: "City is required.",
    validAddressErr: "Please select valid area.",
    areaErr: "Area is required.",
    ageErr: "Age is required.",
    newPasswordErr: "Password is require. Please enter password.",
    newPasswordValidErr: "Please enter valid password.",
    login_type: "Please select user login access.",
    login_access: "Login access",
    justoEmpCodeErr: "Justo employee code is required.",
    // new
    confirmPasswordError: "Password and confirm password should be same.",
    passwordError: "Password should not be empty.",
    emptypassword: "Password should not be empty.",

    // Property_index
    Property: "PROPERTY",
    propertyListing: "Property Listing",
    searchByLocation: "Search By Location",
    searchBylocality: "Search By Locality",
    searchlocality: "Search Locality",
    searchByName: "Search By Name",
    searchByProjectName: "Search By Project Name",
    searchProjectName: "Search Project Name",
    searchName: "Search Name",
    searchByType: "Search By Type",
    addNewProperty: "Add New Property",
    syncAllProperty: "Sync All Project from JW",
    propertyList: "LIST OF PROPERTIES",
    projectName: "Project Name",
    bookingVisit: "Booking",
    location: "Location",
    vistior: "Visitor",
    sitevisit: "Site Visit",
    closeVisit: "Registration",
    status: "Status",
    totalFlat: "Total Flat",
    soldOut: "Sold Out",
    viewProperty: "View Property",
    editProperty: "Edit Property",
    activeProperty: "Active Property",
    deactiveProperty: "Deactive Property",
    activatePropertyTitle: "Activate property",
    deactivatePropertyTitle: "Deactivate property",
    activatePropertyMessage:
      "{{property}} will be marked active and available for allocation and visits.",
    deactivatePropertyMessage:
      "{{property}} will be marked inactive and hidden from active listings.",
    confirmActivate: "Yes, activate",
    confirmDeactivate: "Yes, deactivate",
    greMobileOtp: "GRE Mobile OTP",
    greMobileOtpTitle: "Visitor OTP",
    greMobileOtpHint: "GRE phone verification",
    greMobileOtpEnabled: "Enabled",
    greMobileOtpDisabled: "Disabled",
    greMobileOtpOn: "On",
    greMobileOtpOff: "Off",
    greMobileOtpActivatedTitle: "Phone verification enabled",
    greMobileOtpActivatedMessage:
      "GRE staff at {{property}} must verify the visitor's phone number with OTP before adding a new lead.",
    greMobileOtpDeactivatedTitle: "Phone verification disabled",
    greMobileOtpDeactivatedMessage:
      "GRE staff at {{property}} can add visitors without verifying the phone number.",
    greMobileOtpUpdateFailedTitle: "Could not update phone verification",
    // GRE per-property banner labels (super admin listing + visitor form).
    greBannerTitle: "GRE Banner",
    greBannerHint:
      "Shown on GRE visitor form. Recommended: 1000 × 300 px (displayed at 500 × 150 px), JPG or PNG, max 5 MB.",
    greBannerUpload: "Upload",
    greBannerReplace: "Replace",
    greBannerRemove: "Remove",
    greBannerPreview: "Preview",
    greBannerUpdatedTitle: "Banner updated",
    greBannerRemovedTitle: "Banner removed",
    greBannerUpdateFailedTitle: "Could not update banner",
    greBannerRemoveTitle: "Remove GRE banner",
    greBannerRemoveMessage:
      "Remove the GRE banner for {{property}}? The image will be deleted from memory.",
    greBannerRemoveConfirm: "Yes, remove",
    greBannerUploadModalTitle: "Upload GRE banner",
    greBannerUploadModalReplaceTitle: "Replace GRE banner",
    greBannerUploadFormats: "Supported formats: JPEG, PNG, WebP",
    greBannerUploadMaxSize: "Maximum file size: 5 MB",
    greBannerUploadRecommendedSize:
      "Recommended size: 1000 × 300 px (displayed at 500 × 150 px)",
    greBannerUploadSelectFile: "Choose image",
    greBannerUploadSubmit: "Upload banner",
    greBannerInvalidFormat: "Only JPEG, PNG, or WebP images are allowed.",
    greBannerFileTooLarge: "Image must be 5 MB or smaller.",
    greBannerUploadSelectFileHint: "Drag and drop or click to browse",
    greBannerUploadClearSelection: "Remove image",
    searchByOtpVerification: "Search By OTP Verification Status",
    selectOtpVerification: "--Select OTP Status--",
    crmPersonEmail: "CRM Person Email Id",
    jqProjectID: "JW Project Id",

    // Add New Property

    propertyNameExits: "This Project name is already exits with our system.",
    propertyNameExitsConfirm:
      "Are you sure you want to create new project with same name?",
    addnewproperty: "ADD NEW PROPERTY",
    locationArea: "Location Area",
    typeOfProperty: "Type Of Property",
    costing: "Costing",
    configuration: "Configurations",
    min: "Minimum Budget",
    max: "Maximum Budget",
    inventry: "Inventry",
    remaining: "Remaining",
    amenity: "Amenities",
    optional: "Optional",
    next: "Next",
    Content: "Content",
    addCompetitorProperty: "Add Competitor Property",
    leadFollowup: "Lead Followup",
    propertyAllocation: "Property Allocation",
    selectUser: "Select User",
    selectManager: "Select Manager",
    insentive: "Incentive",
    insentiveType: "Incentive Type",
    amount: "Amount",
    selectType: "--Select Type--",
    back: "Back",
    Loading: "Loading....",
    selectconfiguration: "Select Configuration",

    /*  Business Development/Marketing Property */
    addnewpropertynext: "Add Property Next",
    BusinessDM: "Business Development/Marketing",
    locality: "Locality",
    reraPossession: "RERA Possession Date",
    expectedPossession: "Expected Possession Date",
    landparcel: "Land Parcel",
    units: "--Units--",
    towers: "Towers",
    selectTowers: "--Select Towers--",
    typology: "Typology",
    google: "Google",
    instagram: "Instagram",
    facebook: "Facebook",
    taboola: "Taboola",
    timesquare: "Time Square",
    reraCarpet: "RERA Carpet",
    builtUpArea: "Built Up Area",
    salabelArea: "Saleble Area",
    allInclusive: "All Inclusive",
    paymentScheme: "Payment Scheme",
    stage: "--Select Stage--",
    tentativeClosingPrice: "Tentative Closing Price",
    currentStage: "Current Stage ",
    Positive: "Positive",
    Negative: "Negative",
    supportsForCP: "Supports For CP",
    upcomingInfrastructure: "Upcoming Infrastructure of the location",

    /* BusinessDM */
    MarketingAI: "Marketing Assistance Information",
    MarketingBD: "Marketing/Business Development",
    hoardings: "Hoardings",
    newspaper: "Newspaper",
    fromdate: "From Date",
    toDate: "To Date",
    digitalMarketing: "Digital Marketing",
    whatsappSMS: "Whatsapp/SMS",
    blastRadioJingles: "BlastRadio Jingles",
    /*  */
    residentLocation: "Resident Location",
    officeLocation: "Office Location",
    occupation: "Occupation",
    customerDesignation: "Customer Designation (For Service/Salaried Person)",
    AnnualIncome: "Annual Income",
    ethnicity: "Ethnicity",
    ageGroup: "Age Group",
    rentedOwned: "Current Stay (Rented/Owned)",
    currentStayConfiguration: "Current Stay Configuration",
    customerBudget: "Customer Budget",
    preferredTypology: "Preferred Typology",
    purposeofPurchase: "Purpose of Purchase",
    possessionexpected: "Possession expected Date",

    /* BusinessDMend */

    //form error.
    locationErr: "Locality is required.",
    property_titleErr: "Project Name is required.",
    startDateErr: "Start date is required.",
    locationAreaErr: "Location area is required.",
    validLocationErr: "Please enter valid location area.",
    endDateErr: "End date is required.",
    typeOfPropertyErr: "Type of property is required.",
    jwIDErr: "JW Project id is required.",
    configurationErr: "Is required.",
    areaconfErr: "Is required.",
    minErr: "Is required.",
    maxErr: "Is required.",
    inventryErr: "Is required.",
    remainingErr: "Is required.",
    inventryError: "Please enter valid inventry.",
    remainingError: "Please enter valid remaining.",
    propertyImgErr: "Image is required.",
    propertynameErr: "Property name is required.",
    leadfollowupErr: "Lead followup is required.",
    propertyAllocationErr: "Property Allocation is required.",
    selectRoleErr: "Role is required.",
    selectUserErr: "User is required.",
    selectManagerErr: "Manager is required.",
    insentiveErr: "Incentive is required.",
    amountErr: "Amount is required.",
    validAmount: "Please enter valid amount.",

    // View Property

    propertyDetails: "PROPERTY DETAILS",
    viewPropertyDetails: "View Property Details",
    propertyName: "Property Name",
    propertyType: "Property Type",
    maritalStatus: "Marital Status",
    selectMaritalStatus: "--Select Marital Status--",
    familyMember: "Family Member",
    currentStay: "Current Stay",
    currentStayselect: "--Select Current Stay--",
    content: "Contents",
    images: "Images",
    videos: "Videos",
    catalogue: "Catalogue",
    browserNotSupport: "Your browser does not support the video tag.",
    pickupAllowed: "Pickup Facility",
    allocated: "Allocated :",
    RentedOwned: `Current Stay (Rented/Owned)`,
    CurrentStayConfiguration: "Current Stay Configuration",
    CustomerBudget: "Customer Budget",
    PreferredTypology: "Preferred Typology",
    PurposeofPurchase: "Purpose of Purchase",
    Possessionexpected: "Possession expected",
    youWantDelete: "You want to delete this",
    delete: "Delete",
    imageItem: " image",
    videoItem: "video",
    docItem: "document file",

    // Edit Property
    editproperty: "EDIT PROPERTY",

    // Deactive Property
    activeThisProperty: "Activate this property?",
    deactiveThisProp: "Deactivate this property?",

    // Gallery

    gallery: "Gallery",

    //  Role
    Role: "ROLE",
    roleListing: "Role Listing",
    addNewrole: "Add New Role",
    listOfRole: "LIST OF ROLE'S",
    roles: "Roles",
    edit: "Edit",

    // Add New Role
    addNewRole: "ADD NEW ROLE",
    addnewrole: "Add New Role",
    roleName: "Role Name",
    modules: "Modules",
    parent: "Parent",
    subParent: "Sub Parent",

    // Edit Role
    edtiRole: "EDIT ROLE",
    editrole: "Edit Role",

    //form error
    rolename: "Role Name is required.",

    // Module

    module: "MODULE",
    moduleListing: "Module Listing",
    addNewModule: "Add New Module",
    listOfModule: "LIST OF MODULE'S",

    // Add New Module
    moduleName: "Module Name",
    slug: "Slug",
    sequence: "Sequence Number",
    searchmoduleName: "Search By Module Name",
    parentOptional: "Parent(Optional)",
    searchparentOptional: "Search By Parent",
    selectParent: "--Type Parent Name--",

    // Module_Err
    modulenameisrequired: "Module name is required.",
    sequenceisrequired: "Sequence number is required.",

    // Edit Module
    editModule: "Edit Module",

    // Support Forum_index
    supportForum: "SUPPORT FORUM",
    supportForumList: "Support Forum Listing",
    searchLocation: "Search Location",
    searchByTitle: "Search By Title",
    searchTitle: "Search Title",
    searchByDescription: "Search By Description",
    searchDescription: "Search Description",
    addNewSupportForum: "Add New Support Forum",
    listOfSupportForum: "LIST OF SUPPORT FORUM'S",
    title: "Title",
    description: "Description",
    viewSupportForum: "View Support Forum",
    editsupportforum: "Edit Support Forum",
    deactiveSupportForum: "Deactive Support Forum",
    activeSupportForum: "Active Support Forum",

    // Add New Support Forum
    addNewsupportforum: "ADD NEW SUPPORT FORUM",
    addnewsupportforum: "Add New Support Forum",
    video: "Videos",

    // View Support Forum
    supportForumdDetails: "SUPPORT FORUM DETAILS",
    viewsupportforumdetails: "View Support Forum Details",
    supportforumdetails: "SUPPORT FORUM DETAILS",

    // Edit Support Forum
    editsupportForum: "EDIT SUPPORT FORUM",
    editSupportForum: "EDIT SUPPORT FORUM",

    // Deactive Suppot Forum
    activeThisSupportForm: "Active This Support Forum !",
    deactiveThis: "Deactive This Support Forum !",

    // SupportForum Err
    titleErr: "Title is required.",
    locationerr: "Location is required.",
    validLctionErr: "Please select valid location.",
    descErr: "Description is required.",
    videoErr: "Video is required.",

    // Master
    master: "MASTER",
    masterListing: "Master Listing",
    addNewMaster: "Add New Master",
    listOfMaster: "LIST OF MASTER'S",

    // Add New Master
    typeOfMaster: "Type Of Master",
    selectstatus: "--Select Status--",
    active: "Active",
    inactive: "Inactive",
    propertyConfiguration: "Property Configuration",
    propertyAmenity: "Property Amenity",
    followupStatus: "Followup Status",
    propertyUnsubscribeResion: "Property Unsubscribe Reason",
    leadCancle: "Lead Cancel",
    appointmentType: "Appointment Type",
    unitType: "Unit Type",
    leadSource: "Lead Source",
    PaymentType: "Payment Type",
    SupportType: "Support Type",
    cluster: "Cluster",
    cpType: "CP Type",
    selectCpType: "Select Cp Type",
    nameOfCp: "Name of CP",
    mobileNumber: "Mobile Number",
    cpEmailAddress: "Email Address",
    ethniCity: "Ethnicity",

    //Master_Err
    titleisrequired: "Title is required.",

    // Agency(CP)_index
    channelPartner: "Channel Partner",
    channelPartnerListing: "Channel Partner Listing",
    listOfChannelPartner: "LIST OF CHANNEL PARTNER'S",
    visits: "Visits",
    cpName: "CP Name",
    channelPartnerName: "Channel Partner Name",
    agentName: "Agent Name",
    agentCode: "Agent Code",
    noOfsiteList: "No. of Site List",
    property_name: "Property Name",
    noOfClosingLead: "Total Closer Visit",
    closingPercentage: "Closing Percentage",
    approved: "Approval",
    viewChannelPartner: "View Channel Partner",
    addNewCP: "Add New Channel Partner",
    editCp: "Edit Channel Partner",
    lastLogin: "Last Login",
    lastLeadCreate: "Last Lead Create",
    lastSiteVisit: "Last Site Visit",
    lastCloseVisit: "Last Close Visit",
    reraStartDate: "Rera start date",
    reraEndDate: "Rera end date",
    approveNewCp: "Approve new CP",
    allocateProperty: "Allocate Property",
    allocateCpToSm: "Allocate CP To Sm",
    reraNo: "RERA No",
    noOfBookings: "No. of Booking",
    createdDateTime: "Created Date & Time",
    reraCertificateNo: "Rera Certificate No",
    AllocatedProjecbookingCount: "Booking Count",
    AllocatedProjecVisitorCount: "Visitors Count",
    AllocatedProjecWalkInCount: "Walk In Count",

    // Agent_List
    cpAgnet: "CP Agent",
    agentListing: "CP Agent Listing",
    listOfAgent: "LIST OF CP Agent",
    agentDetail: "CP AGENT DETAILS",
    viewAgent: "View CP Agent Details",

    // View Channel Partner
    channelPartnerDetail: "CHANNEL PARTNER DETAILS",
    companyDetals: "COMPANY DETAILS",
    viewchannelpartner: "View Channel Partner Details",
    channelPartnerDetails: "CHANNEL PARTNER DETAILS",
    channelBankDetails: "BANK DETAILS",
    stats: "Stats",
    cpAgentDetails: "CP Agent List",
    agencyInfo: "Agency Info.",
    cpBankDetail: "CHANNEL PARTNER BANKING DETAILS",
    agentBankDetail: "CP AGENT BANKING DETAILS",
    agencyBankDetail: "COMPANY BANKING DETAILS",
    bankName: "Bank Name",
    branchName: "Branch Name",
    accountNo: "Account Number",
    ifscCode: "IFSC Code",
    noOfAgent: "Total Agent :",
    createDate: "Create Date",
    activeBy: "Active By",
    noOfSiteVisit: "Total Site Visit",
    cpProfile: "Profile",
    agencyName: "Agency Name",
    ownerName: "Name of CP",
    aadharNo: "Aadhaar Number",
    aadharNoExample: "EX:- 1234 1234 1234",
    gst: "GST Number",
    companyGST: "Company GST Number",
    reraRegistration: "Company RERA No.",
    companyMailID: "Company Email Id",
    cpMailID: "CP Email Id",
    companyAddress: "Company Address",
    reraCertificate: "Channel Partner RERA Certificate",
    companyReraCertificate: "Company RERA Certificate",
    pan: "PAN",
    email: "Email",
    whatsappNo: "Whats'app Number",
    sourcingManager: "Sourcing Manager",
    closingManager: "Closing Manager",
    workingLocation: "Working Location",
    verifyCP: "Verify Channel Partner",
    youWantVerifyCP: "You want to verify this Channel partner !",

    // Add_CP
    realStateCompany: "Company Name",
    panNumber: "Pancard Number",
    propDeclarLetter: "Proprietorship Declaration Latter",
    reraCertiNumber: "Channel Partner RERA No.",
    bankDetailUser: "Channel Partner Bank Details",
    cancelCheaque: "Cancel Cheaque",
    companyInformation: "Company Information",
    pancard: "Company Pancard",
    companyDeclarLetter: "Declaration Latter of Company",
    bankDetailCompany: "Company Bank Details",
    selectSM: "-- Select Sourcing Mananger --",
    worklocationerr: "Working location is required.",
    individual: "Individual",
    company: "Company",
    applicableforGST: "Are you applicable for GST - Yes or No",
    addNewEmp: "Add New Employee",
    empName: "Employee Name",
    empMobile: "Employee Mobile No.",
    companyMobile: "Company Mobile No.",
    empEmail: "Employee Email",
    employee: "Employee",
    removeEmp: "Remove Employee",
    chooseFile: "Choose file",
    reraValidationMsg:
      "MAHA RERA - (eg: A12345678901) \nUP RERA - (eg: UPRERAABC12345678)",
    allocatepropertytocp: "Please allocate property to cp",

    // channel_partner_form_err
    owner_Err: "Channel Partner name is required.",
    rera_Number_Err: "RERA certificate number is required.",
    company_rera_Number_Err: "Company RERA certificate number is required.",
    validCertificateNo: "Please enter valid RERA certificate number.",
    rera_Certificate_Err: "RERA certificate is required.",
    prop_delcare_Err: "Proprietorship declaration letter is required.",
    bank_Name_Err: "Bank name is required.",
    branch_Name_Err: "Branch name is required.",
    account_number_Err: "Account Number is required.",
    account_valid_Err: "Please enter valid account number.",
    ifsc_Err: "IFSC code is required.",
    ifsc_valid_Err: "Please enter valid IFSC code.",
    cancel_cheaque: "Cancel cheaque is required.",
    agency_Err: "Company name is required.",
    gst_Err: "GST number is required.",
    gst_Valid_Err: "Please enter valid GST number.",
    rera_register_Err: "Company RERA No. is required.",
    validReraRegister: "Please enter valid RERA registration.",
    company_pan_Err: "Pancard is required.",
    company_letter_Err: "Company declaration letter is required.",
    companyAddressErr: "Company Address is required.",
    employee_Err: "Employee is required.",
    empNameErr: "Employee name is required.",
    empMobileErr: "Employee mobile no. is required.",
    empEmailErr: "Employee email is required.",
    pincodeErr: "Please enter valid pincode",

    //  Visitor_index
    visitor: "Visitor",
    visitorList: "Visitor Listing",
    searchByVisitorName: "Search By Visitor Name",
    searchVisitorName: "Search Visitor Name",
    searchByConfiguration: "Search By Configuration",
    searchByPropertyName: "Search By Property Name",
    selectConfiguration: "--Select Configuration--",
    searchByVistingScore: "Search By Visiting Score",
    selectVisitingScore: "--Select Visiting Score--",
    howToligh: "Low To High",
    highTolow: "High To Low",
    listOfVisitor: "LIST OF VISITOR'S",
    visitorName: "Visitor Name",
    sourceName: "Source Name",
    budget: "Budget",
    viewVisitor: "View Visitor",
    editVisitor: "Edit Visitor",
    updateDraftVisitor: "Update Visitor Draft",
    visitScore: "Visiting Score",
    cpLeadType: "CP Lead Type",
    selectLeadType: "Select Lead Type",
    teleCalling: "Tele-calling",
    direct: "Direct",
    searchByMobileNumber: "Search By Mobile Number",
    searchMobileNumber: "Search Mobile Number",
    walk_in: " Walk-in",
    searchByVistingType: "Search By Visiting Type",
    selectVisitingType: "--Select Visiting Type--",
    visitors: "Visitors",
    draftVisitors: "Draft Visitors",
    selectByPropertyName: "Select By Property Name",
    visitingWith: "Visiting With",
    selectEthnicity: "--Select Ethnicity--",
    expectedPossessionPeriode: "Expected Possession",
    selectExpectedPossession: "-- Select Expected Possession--",
    budgetAmount: "Budget Amount",
    selectBudgetAmount: "-- Select Budget Amount--",

    // View Visitor Details
    visitorDetails: "Visitor Details",
    viewvisitordetails: "View Visitor Details",
    lastInteracted: "Last Interacted :",
    source: "Source",
    propertyRequired: "PROPERTY REQUIRED",
    Area: "Area (in sq.ft)",
    natureOfFunding: "Nature of Funding :",
    purpose: "Purpose :",
    customerDetails: "CUSTOMER DETAILS",
    companyDetails: "COMPANY DETAILS",
    nameOfOccupation: "Occupation :",
    companyName: "Company Name",
    designation: "Designation :",
    officeAddress: "Office Address :",
    houseNo: "House No",
    officeArea: "Area",
    landmark: "Landmark",
    pincode: "Pincode",
    statusUpdate: "Status Update",
    scheduleSiteVisit: "Schedule Site Visit",
    emname: "Emp. Name",
    createdByRole: "Created By Role",
    created: "Created",

    // Edit Visitor
    editvisitor: "EDIT VISITOR",
    updatedraftvisitor: "UPDATE VISITOR DRAFT",
    visitorListing: "Visitor Listing",
    expectedPossesionDate: "Expected Possesion Date",
    minBudget: "Min Budget",
    maxBudget: "Max Budget",
    natureOffunding: "Nature of Funding",
    loan: "Loan",
    selfFunding: "Self Funding",
    both: "Both",
    Purpose: "Purpose",
    endUser: "End User",
    invesment: "Investment",
    preferredBank: "Preferred Bank",
    visitorFirstName: "Visitor First Name",
    visitorFullName: "Visitor Full Name",
    visitorLastName: "Visitor Last Name",
    pancardNo: "Pancard Number",
    panNumberExample: "ex:- BNZAA2318M",
    dateofBirth: "Date of Birth",
    salaried: "Salaried",
    minEMIpay: "Min EMI Pay",
    maxEMIpay: "Max EMI Pay",
    selfEmployed: "Self Employed",
    professional: "Professional",
    desigantion: "Designation",
    officeaddress: "Office Address",
    married: "Married",
    unmarried: "Unmarried",
    rented: "Rented",
    owned: "Owned",
    moveIn: "Move In",
    underConstruction: " Under Construction",
    viaIndividual: "Via Individual CP",
    viaCompany: "Via CP Company",
    chooseCP: "Select CP",
    cpCompany: "CP Company Name",
    selectCpCompany: "Select CP Company Name",
    companyEmployName: "Company Employee name",
    selectEmployeeName: "Select Employee name",
    cpEmployeeName: "CP Employee name",
    createAndSchedule: "Create and Schedule",
    family: "Family",
    couple: "Couple",
    friend: "Friend",
    single: "Single",
    business: "Business",
    homeMaker: "Home Maker",
    retired: "Retired",
    others: "Others",
    workLocation: "Work Location",
    leadStatus: "Lead Status",
    leadPriority: "Lead Priority",
    qualified: "Qualified",
    unQualified: "Unqualified",
    hot: "Hot",
    warm: "Warm",
    cold: "Cold",
    selectLeadStatus: "Select Lead Status",
    selectLeadPriority: "Select Lead Priority",

    three_to_six_month: "3 – 6 Months",
    six_to_one_year: "6 Months – 1 Year",
    one_year_to_two_year: "1 – 2 Years",
    two_year_and_above: "2 Years and Above",

    below_50_lakhs: "Below - 50L",
    fifty_lakhs_to_seventy_five_lakhs: "50L - 75L",
    seventy_five_lakhs_to_one_crore: "75L - 1Cr",
    one_crore_to_1_30_crore: "1Cr - 1.30Cr",
    one_31_crore_to_1_50_crore: "1.31Cr - 1.50Cr",
    one_51_crore_to_1_75_crore: "1.51Cr - 1.75Cr",
    one_76_crore_to_2_crore: "1.76Cr - 2Cr",
    two_crore_to_2_5_crore: "2Cr - 2.5Cr",
    above_2_5_crore: "2.5Cr and above",

    // Edit Visitor_Error
    configuration_Err: "Configuration is required.",
    expected_possession_date_Err: "Expected possession date is required.",
    areain_sqlft_Err: "Area (in sq.ft) is required.",
    areain_sqlft_Nan_Err: "Enter only number.",
    firstName_Err: "Visitor name is required.",
    birthDate_Err: "Birth date is required.",
    mobile_Err: "Mobile number is required.",
    location_Err: "Location is required.",
    desigantion_Err: "Designation is required.",
    officeAddress_Err: "Office address is required.",
    budget_Err: "Please enter valid budget.",
    adhar_no_Err: "Aadhaar number is required.",
    validAadhar_Err: "Please enter valid aadhaar number.",
    pancard_no_Err: "Pancard number is required.",
    validPancard_Err: "Please enter valid pancard number.",
    purposeErr: "Purpose is required.",
    fundingErr: "Funding Type is required.",
    occupationErr: "Occupation is required.",
    annualHouseholdIncome: "Annual Household Income",
    selectAnnualHouseholdIncome: "Select Annual Household Income",
    annualHouseholdIncomeErr: "Annual household income is required.",

    // Visitor_popup_modal
    useOldData: "Use Old Data",
    createNew: "Create New",
    conformation: "Confirmation",
    checkMobileNumber: "Please check entered mobile number",
    mobileNoWithoutCountryCodeHint:
      "Enter mobile number without country code (+91).",
    mobilePlaceholderGre: "10-digit mobile number",
    mobileOtpEnterValid: "Enter a valid 10-digit mobile number to send OTP",
    mobileOtpChangeNumber: "Change number",
    otpCardSubtitle: "We've sent a 4-digit code to",
    otpDidntReceive: "Didn't receive the code?",
    sendOtpToVerify: "Verify Mobile Number",
    otpSent: "OTP Sent",
    enterOtpSentTo: "Enter the 4-digit OTP sent to",
    verifyOtp: "Verify OTP",
    mobileVerifiedSuccess: "Mobile number verified",
    verifyMobileWithOtp: "Please verify mobile number with OTP",
    clearOtp: "Clear OTP",
    otpSentSuccess: "OTP sent successfully",
    otpResentSuccess: "OTP resent successfully",
    otpVerifySuccess: "Phone number verified successfully",
    otpSendFailed: "Failed to send OTP",
    otpVerifyFailed: "Failed to verify OTP",
    otpInvalid: "Invalid OTP. Please try again.",
    otpEnterFourDigits: "Please enter 4-digit OTP",

    // Appointment
    appointment: "APPOINTMENT",
    appointmentList: "Appointment Listing",
    appointmentWith: "Appointment with",
    appointWith: "--Appointment with--",
    siteLeadVisit: "Site Lead Visit",
    clientVisit: "Client Visit",
    searchByCustomerName: "Search By Customer Name",
    searchCustomerName: "Search Customer Name",
    searchByStatus: "Search By Status",
    panding: "Pending",
    readyToBook: "Ready To Book",
    confirm: "Confirm",
    complete: "Complete",
    searchPropertyName: "Search Property Name",
    listofappointment: "LIST OF APPOINTMENT'S",
    siteVisitTimeDate: "Site Visit Date & Time",
    siteRevisitVisitTimeDate: "Revisit Visit Date & Time",
    customerName: "Customer Name",
    visitingScore: "Visiting Score",
    upcoming: "Upcoming",
    visitStatus: "Visit Status",
    bookingreadytobook: "Booking/Ready to Book",
    revisit: "Revisit",
    visitcancelled: "Visit Cancelled",
    notfitforseal: "Not Fit for Sale",
    actualvisit: "Actual Visits",
    allAppointment: "All Appointments",
    todayAppointments: "Today Appointment",

    // View Appointment
    viewAppointmentDetails: "APPOINTMENT DETAILS",
    viewappointmentdetails: "View Appointment Details",
    appointmentDetails: "APPOINTMENT DETAILS",
    whenToBuy: "When to buy :",
    property: "Property",
    pickupLocation: "Pickup Location :",
    dropLocation: "Dropup Location :",
    noOfGuest: "No. of Guest :",
    reason: "Reason",
    closingStatus: "Closing Status",
    checkInStatus: "Check in status",
    notInterested: "Not Interested",
    bookNow: "Book Now",
    followUp: "Follow-up",
    noShow: "No Show",
    visitorCheckin: "Visitor Check In",
    confirmCheckin: "Please confirm the visitor checkin",
    selectReason: "Select Reason",
    assignTo: "Assign To",
    allocate: "Allocate",
    allocateToCM: "Allocate to CM",
    allocatedToCM: "Allocated to CM",
    alreadyAllocated: "Already allocated",
    currentlyAllocatedTo: "Currently allocated to",
    reassignToCM: "Reassign",
    cmClearSelection: "Clear",
    notAllocatedToCM: "Not allocated",
    reAllocateToCM: "Re-Allocate",
    reassignVisitorToCM: "Reassign Visitor to Closing Manager",
    allocateVisitorToCM: "Allocate Visitor to Closing Manager",
    reAllocateVisitorToCM: "Re-Allocate Visitor to Closing Manager",
    selectNewClosingManager: "Select New Closing Manager",
    updateVisitordetails: "Update Visitor Details",
    viewVisitorHistory: "View Visitor History",

    // Edit Appointment
    editAppointment: "EDIT APPOINTMENT",
    EditAppointment: "Edit Appointment",
    selectLead: "Select Lead",
    selectlead: "--Select Lead--",
    selectProperty: "Select Property",
    selectproperty: "--Select Property--",
    AppointmentDate: "Appointment Date",
    AppointmentTime: "Appointment Time",
    AppointmentTimeDetail:
      "Please Select Appointment Time 10:00 AM to 07:00 PM",
    Pickup: "Pickup(if add property time set yes)",
    pickuplocation: "Pickup Location",
    numberofGuest: "Number of Guest",
    pickupLocationErr: "Pickup Location is required.",
    numberOfGuest: "Number of guest is required.",
    validNumber: "Please enter valid number.",
    rescheduled: "Rescheduled",
    appointmentCancel: "Appointment Cancel",

    // Add Appointment
    addAppointment: "Add New Appointment",
    pickup: "Pickup",
    leadErr: "Lead is required.",
    ValidTimeErr: "Please Select Appointment Time 10:00 AM to 7:00 PM ",
    validTime: "Please select the time",

    //  New Upload
    newupload: "NEW UPLOAD",
    newuploadListing: "New Upload Listing",
    searchByname: "Search By Name",
    listofnewupload: "LIST OF NEWUPLOAD'S",
    cpname: "CP Name",
    noOfVisitor: "Total Visitor",
    closingLead: "Closing Lead",
    visitorScore: "Visitor Score",
    createVisitor: "Create Visitor",

    // Verify Lead
    VerifyVisitor: "Verify Visitor",
    verifyListing: "Verify Visitor Listing",
    listOfVerifyVisitor: "List Of Verify Visitor",
    urgency: "Urgency",
    searchByRole: "Search By Role",
    viewVerifyLead: "View Verify Lead",
    addVerifyLead: "Add Verify Lead",
    viewVerifyVisitor: "View Verify Visitor Details",

    // Error
    customerName_Err: "Visitor name is required.",

    // Create Visitor
    createvisitor: "CREATE VISITOR",
    CreateVisitor: "Create Visitor",
    propertyname: "Property Name",
    addNewVisitor: "Add New Visitor",

    // Bulk Upload
    bulkUpload: "Bulk Upload",
    imageUpload: "Image Upload",
    csvUpload: "CSV Upload",
    upload: "Upload",
    csv: "CSV File",
    csvFile: "CSV File is required.",
    downloadCsvFile: "Download CSV Sample",

    // Followup_index
    followup: "Followup",
    followupList: "Followup Listing",
    todayFollowupList: "Today Followup Listing",
    listOfFollowup: "LIST OF FOLLOWUP'S",
    listOfTodayFollowup: "LIST OF TODAY FOLLOWUP'S",
    followupDate: "Date",
    followupDateTime: "Next Followup D & T",
    vistiorName: "Visitor Name",
    followType: "Follow Type",
    lead: "Lead",
    leadType: "Lead Type",
    siteVisit: "Appointment",
    booking: "Booking",
    registration: "Registration",
    viewfollowup: "View Followup ",
    EditFollowup: "Edit Followup",
    viewallfollowUp: "View All Followup",
    viewHistory: "View History",

    // View Followup Details
    viewfollowupDetails: "FOLLOWUP DETAILS",
    viewfollowupdetails: "View Followup Details",
    followupDetails: "FOLLOWUP DETAILS",

    // Edit Followup
    editFollowup: "EDIT FOLLOWUP",

    // Edit Followup ERROR
    followupStatusErr: "Followup status is required.",
    visitStatusErr: "Lead type is required.",
    followup_dateErr: "Date is required.",
    followup_timeErr: "Time is required.",
    remarkErr: "Description is required.",
    appointmentWithErr: "Appointment with is required",
    appointmentTypeErr: "Appointment type is required",

    // All Followup
    allFollowup: "ALL FOLLOWUP",
    allfollowup: "All Followup",
    followupBy: "Followup By",
    date: "Date",

    //Schedule activity followup
    scheduledFollowup: "Scheduled Followup",
    scheduledFollowupList: "Scheduled Followup List",
    scheduledlistOfFollowup: "Scheduled list Of Followup",
    followupRemark: "Remark",
    closingRemark: "Closing Remark",
    closingDateTime: "Closing D & T",
    followUPDateTime: "Followup D & T",
    walkinRemark: "Walk-in Remark",
    addVisitorFollowupDate: "Follow-up Date",
    addVisitorFollowupTime: "Follow-up Time",
    dueFollowUps: "Due Followups",
    nextDayCall: "Next Day Call",
    invalidTimeError: "Please select a future time for today.",

    // Update Status Follow
    newFollowup: "NEW FOLLOWUP",
    NewFollowup: "New Followup",
    updateFollowup: "UPDATE FOLLOWUP",
    time: "Time",

    // Chat Screen
    chatScreen: "CHAT SCREEN",
    recentChat: "Recent Chat",
    chat: "Chat",
    typeAmessage: "Type a message......",
    send: "Send",
    userNotSelect: "User not selected.",
    startChat: " Please select user and start chat.",

    // Raise Ticket_index(Support_Ticket)
    raiseTicket: "RAISE TICKET",
    raiseTicketList: "Raise Ticket Listing",
    searchByIssue: "Search By Issue",
    listOfRaiseTicket: "LIST OF RAISE TICKET'S",
    ticket: "Ticket",
    createBy: "Create By",
    closeBy: "Close By",
    remark: "Description",
    updateBy: "Update By",
    updateDate: "Update Date",
    issue: "Issue",
    viewSupportticket: "View Support Ticket",
    updateStatus: "Update Status",
    searchByTicketNo: "Search By Ticket Number",
    selectIssue: "--Select Issue--",
    exportList: "Export",
    propertyTitle: "Property Title",
    supportRequest: "Support Request",
    myTicket: "My Ticket",

    //  View Raise  Ticket Details
    supportticketdetails: "RAISE TICKET DETAILS",
    viewsupportticketdetails: "View Raise Ticket Details",
    supportTicketDetails: "RAISE TICKET DETAILS",
    raiseReply: "Raise Ticket Reply",
    ticketNo: "Ticket No.",
    updateByName: "Updated By",

    // Update Raise Ticket(Support)
    updateSupportticket: "UPDATE RAISE TICKET",
    updatesupportticket: "Update raise Ticket",
    updateSupportTicket: "UPDATE RAISE TICKET",
    editRaiseTicketReply: "Edit Raise Ticket Reply",
    selectStatus: "Select Status",
    open: "Open",
    statusErr: "Status is required.",

    //Add And Edit Raise Ticket
    editRaiseTicket: "Edit Raise Ticket",
    addRaiseTicket: "Add Raise Ticket",
    editTicket: "Edit Ticket",
    addTicket: "Add Ticket",
    issueErr: "Issue is required.",

    // Configuration_Setting
    // email
    configurationSetting: "Configuration Setting",
    configurationEmail: "Configuration Email",
    smtpKey: "SMTP Key",
    smtpUserId: "SMTP User ID",

    // registraion screeen
    registraionListing: "Registration Listing",
    viewRegistraion: "Registration Details",

    // Booking
    bookingListing: "Booking Listing",
    viewBooking: "Booking Details",
    confirmListing: "Confirm Listing",
    viewConfirmListing: "View Confirm Booking",

    // Email_Err
    emailValidationErr: "Please enter valid email.",
    useremailErr: "Please enter valid email or username.",
    smtpKey_Err: "Smtp key is required.",
    smtpuserId_Err: "User Id is required.",
    smtpPassword_Err: "Password is required.",

    // massage
    configurationMassage: "Configuration Message",
    accountSID: "Account SID",
    authToken: "Auth Token",
    accountID: "Account ID",

    // massage_Err
    accountSid_Err: "Account SID is required.",
    authToken_Err: "Auth token is required.",
    accountId_Err: "Account Id is required.",

    // notification
    notificationMapKey: "Notification Map Key",
    mapKey: "Map Key (for the google location)",
    fcmKey: "FCM Key (for notification)",

    // notification_Err
    mapKey_Err: "Map Key is required.",
    fcmKey_err: "Fcm Key is required.",

    // publicLead
    publicLead: "Public Lead",
    leadSourceErr: "Lead source is required.",
    forSmIdErr: "Sourcing Manager is required.",
    chanelPartnerType: "Channel Partner type is required.",
    chanelPartnerRequired: "Channel Partner Required",
    propertyRequire: "Property Require",
    companyDetail: "Company Details",
    prop_titleErr: "Please select Property name.",
    selectProp: "--Select Property--",
    selectPropType: "--Select Property Type--",
    close: "Close",
    done: "Done",
    invalidRequest: "Invalid Request",
    amountTypeErr: "Please select amount type.",
    amountEror: "Please enter maximum amount more than minimum amount.",
    amountMaxEror: "Please enter maximum amount.",
    amountMinEror: "Please enter minimum amount.",
    amountMaxEmiEror: "Please enter maximum emi amount.",
    amountMinEmiEror: "Please enter minimum emi amount.",
    fieldRequired: "Please fill required fields.",
    missingRequiredFieldsPrefix: "Please fill the following required fields:",
    thankYou: "Thank You!",
    visitSubmitted:
      " Your visit has been submitted. Someone from our team will contact you shortly.",
    remarkField: "Remark",
    selectLeadSource: "--Select Lead Source--",
    leadForSoursingManager: "Lead for Sourcing Manager",
    leadForSmGreHint: "(to be filled by the executive)",
    selectSourcingManager: "--Select Sourcing Manager--",
    selectClosingManager: "--Select Closing Manager--",
    selectSM_Manager: "Select Sourcing Manager",
    assignToNewClosingManager: "Assigned to New Closing Manager",

    // ERROR_PAGE
    backHomePage: "BACK TO HOME PAGE",
    unAuthorized: "Unauthorized person, not permitted beyond this point",

    // Call_center_dashboard
    // Privacy Policy
    editPrivacyPolicy: "Edit Privacy Policy",

    // Term And Condition
    editTermAndCondtion: "Edit Term And Condition",

    // Booking_management
    bookingList: "List of Booking's",
    bookingDate: "Booking Date",
    bookingAmount: "Booking Amount",
    currentStatus: "Current Status",
    bookingNumber: "Booking Number",
    bookingBy: "Booking By",
    chequeNumber: "Cheque Number",
    confiQty: "Configuration Qty",
    bookingCancel: "Booking Cancel",
    addBooking: "Add Booking",
    flatName: "Flat Name",
    floors: "Floors",
    attachPhoto: "Attach Photo",
    carpetArea: "Carpet Area",
    comment: "Comment",
    creditCard: "Credit Card",
    upi: "UPI",
    cheque: "Cheque",
    debitCard: "Debit Card",
    neft: "Neft",
    paymentType: "Payment Type",

    // registration_management
    registraionList: "List of Registration's",
    paymentMode: "Payment Mode",
    leadby: "Lead By",
    registerAmount: "Register Amount",
    registerBy: "Register By",

    // report
    report: "Report Management",
    kpiReport: "KPI Tracker Report Management",
    reportManageList: "Report Manage Listing",
    kpiTrackerList: "KPI Tracker Report Listing",
    reportListing: "Report Listing",
    bySite: "Search By Site",
    selectSite: "--Select Site--",
    byEmployee: "Search By Employee",
    SelectEmployee: "--Select Employee--",
    byCPName: "Search By Channel Partner Name",
    selectCPName: "--Select Channel Partner Name--",
    conversionFunnel: "Conversion Funnel",
    parameters: "Parameters",
    count: "Counts",
    mtd: "MTD",
    Ytd: "YTD",
    LastSevenDays: "Last 7 Days",
    LastThirtyDays: "Last 30 days",
    cpCount: "CP Count :",
    leadCount: "lead Count :",
    bookingCount: "Booking Count :",
    TotalCPMapRegisteredtillDate: "Total Maped CP :",
    NewCPRegisteredFTM: "New CP Registered :",
    TotalNewCPRegisteredFTM: "Total CP Registered :",
    BookingDone: "Booking Done :",
    TotalBookingDone: "Total Booking Done :",
    VisitorsEntry: "Visitors Entry :",
    TotalVisitorsEntry: "Total Visitors Entry :",
    leads: "Leads",
    SiteVisitCreated: "Site Visit Created",
    WalkIns: "Walk-ins",
    reportUser: "Report",
    todayReport: "Today Report",

    SiteVisitCreate: "Site Visit Create :",
    TotalSiteVisitCreate: "Total Site Visit Create :",
    ActualVisit: "Actual Visit :",
    TotalActualVisit: "Total Actual Visit :",
    Revisit: "Revisit :",
    TotalRevisit: "Total Revisit :",
    CustomerLost: "Customer Lost :",
    TotalCustomerLost: "Total Customer Lost :",
    Noshowvisit: "No Show Visit :",
    TotalNoshowvisit: "Total No Show Visit :",
    ReportBookingCancel: "Booking Cancel :",
    TotalReportBookingCancel: "Total Booking Cancel :",
    checkin: "Checkin :",
    totalCheckins: "Total Checkins :",

    // Report_Management
    totalCountForall: "Total counts for all projects",
    totalUser: "Total Employees",
    activeEmp: "Active Employees",
    deactiveEmp: "Deactive Employees",
    listTotalUser: "List of total Employees",
    listActiveUser: "List of active Employees",
    listDectiveUser: "List of deactive Employees",
    searchByModuleName: "Search By Module Name",
    searchByUserName: "Search By User Name",
    UserActivityList: "User Activity Report",
    userName: "User Name",
    access: "Access Module",
    ftd: "FTD",

    // Web_Report
    roleWiseReport: "Role Wise Report",
    rolewiseProject: "Project Roll wise data",
    roleswiseAllProject: "All project Roll wise data",
    projectDetailsReport: "Project Details Report",
    allProjectDetails: "All project data",
    siteVisits: "Site Visits",
    bookings: "Bookings",
    onDate: "On Date",
    allProjects: "All Projects",
    submitted: "Submitted",
    reVisits: "Site Revisits",

    // followupStatus: "Follow up Status",
    LeadQuality: "Lead Quality",
    teamPerformance: "Team Performance",
    teamCPPerformance: "CP Performance",
    fifty: "<50",
    fifityseventy: "50-70",
    seventyplus: "70+",
    total: "Total",
    department: "Department",
    teamMemberName: "Team Member Name",
    visitorsActual: "Visitors (Actual)",
    bookingsActual: "Bookings (Actual)",

    // Support_Contact_us
    constactUs: "Contact Us",
    headOffice: "HEAD OFFICE",
    phone: "Phone",
    website: "Website",

    // User Announcement
    userAnnouncement: "User Announcement",
    sendTo: "Send To",
    justoUser: "Justo User",
    message: "Message",
    select: "Select",
    selectedUser: "Selected User",
    allUser: "All User",
    selectCP: "Selected Channel Partner",
    allCp: "All Channel Partner",
    sendToErr: "Please select user or channel partner.",
    selectcpErr: "Channel partner is required.",
    messageErr: "Message is required.",
    propertyErr: "Please select property.",

    //newdash
    channelPartners: "Channel Partners",
    appointments: "Appoinments",
    customers: "Customers",

    //deposit report
    depositionReport: "Disposition Report",

    //Chanel Partner Report
    getAllChanelPartnerData: "Channel Partner Report",
    getAllChanelPartnerDataListing: "Channel Partner Report Listing",

    //Channel Partner Appointment Report
    channelpartnerappointments: "Channel Partner Appointment Report",
    channelpartnerappointmentsListing:
      "Channel Partner Appointment Report Listing",
    serchByCpName: "Search By Cp Name",
    serchBySMName: "Search By SM Name",
    serchBySTLName: "Search By STL Name",

    //closing managers
    closingManagerList: "Lsit of Closing Managers",
    closingManagerListing: "Closing Manager Listing",
    noBookings: "No of bookings",
    viewClosingManager: "View Closing Manager",
    editClosingManager: "Edit Closing Manager",
    cmDetails: "CM Details",
    cmInfo: "CM INFO",

    //sm
    noOfSiteVisits: "No of Site Visit",
    noOfLeads: "No of Leads",
    viewSourcingManager: "View Sourcing Manager",
    editSourcingManager: "Edit Sourcing Manager",
    conversionPercentage: "Conversion Percentage",
    sourcingManagerListing: "Sourcing Manager Listing",
    sourcingManagerList: "Lsit of Sourcing Managers",
    smDetails: "SM Details",
    smInfo: "SM INFO",
    totalVisits: "Total Visit",
    fullName: "Full Name",
    allocateCp: "Allocate Cp",

    //appointmentWith cp
    apptWithCp: "Appointment With CP",
    appointmentListCP: "Appointment With CP Listing",
  },
});

export default strings;
